// extracted by mini-css-extract-plugin
module.exports = {"toasts":"Toasts-module__toasts___3W08F","toast":"Toasts-module__toast___1t3Xv","shown":"Toasts-module__shown___BcnbH"};